import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "./SmoothScroll";
import { CONTACT } from "../data";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Process", id: "process" },
  { label: "Work", id: "gallery" },
  { label: "Clients", id: "testimonials" },
  { label: "Coverage", id: "coverage" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "bg-obsidian/85 backdrop-blur-xl border-border"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("hero")}
          className="font-display text-lg uppercase tracking-tight flex items-center gap-2 text-white"
        >
          <span className="w-2.5 h-2.5 bg-acid" />
          Pure Space
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm uppercase tracking-[0.15em] text-zinc-400 hover:text-acid transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-phone"
            className="hidden md:block text-sm uppercase tracking-[0.15em] text-white hover:text-acid transition-colors"
          >
            {CONTACT.phone}
          </a>
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("quote")}
            className="hidden sm:inline-flex items-center border border-acid text-acid px-6 py-3 text-xs uppercase tracking-[0.2em] font-bold hover:bg-acid hover:text-obsidian transition-colors duration-300"
          >
            Get a Quote
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-obsidian border-t border-border px-6 py-6 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-lg font-display uppercase text-white hover:text-acid transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-quote-btn"
            onClick={() => go("quote")}
            className="mt-2 bg-acid text-obsidian px-6 py-3 text-xs uppercase tracking-[0.2em] font-bold"
          >
            Get a Quote
          </button>
        </div>
      )}
    </motion.header>
  );
}
